import React from 'react';
import styles from './Card.module.css';

const Card: React.FC<{ additionalStyles?: string }> = (props) => {
    const { children, additionalStyles } = props;
    return <div className={`${styles.wrapper} ${additionalStyles}`}>{children}</div>;
};

export default Card;
